import React, { useEffect } from "react";
import CircleLoader from "../notes/component/CircleLoader";
import { isAndroidDevice, isMobile } from "../../helper/CommonFuncs";
import { withRouter } from "react-router";
import { SignUpProvider } from "../newProviderApp/actions/apis";
import { isLoadedOnWebView, openAppEpic } from "../newProviderApp/actions/helpers";
import { epicSaLaunch } from "../../api/onboarding";
const FhirClientStandAloneComponent = (props) => {
   const history = props.history;
   useEffect(() => {
      const searchParams = new URLSearchParams(props.location.search);
      const code = searchParams.get("code");
      const state = searchParams.get("state");

      if (code && state) {
         const searchParam = window.location.search;
         if (window.location.host === "provider.playbackhealth.com") {
            window.location.replace("https://pro.playbackhealth.com/callback_standalone" + searchParam);
            return;
         }
         if (isLoadedOnWebView()) {
            loginEpicUserDemo(code);
            return;
         }
         if (isMobile()) {
            let strAndroid = "?code=" + code + "&state=" + state;
            let uriIos = "com.playbackhealth.pro://";
            let uriAndroid = "com.playbackhealth.pro://";
            if (process.env.REACT_APP_URL === "https://dev-api.playbackapi.com") {
               uriIos = "com.playbackhealth.providers://";
               uriAndroid = "com.playbackhealth.providers://";
            }
            if (isAndroidDevice()) {
               window.location = uriAndroid + strAndroid;
            } else {
               window.location = uriIos + strAndroid;
            }
         } else {
            loginEpicUser(code);
         }
      }
   }, []);

   const restApiCall = async ({ code, key, callback = () => {}, error = () => {} }) => {
      const response = await epicSaLaunch({
         code: code,
         key: key,
      });
      if (response) {
         callback(response);
      } else {
         error();
      }
   };

   const loginEpicUserDemo = (code) => {
      const storedEpicLoginKey = localStorage.getItem("epicLoginKey");
      if (!storedEpicLoginKey && process.env.REACT_APP_URL === "https://dev-api.playbackapi.com") {
         return;
      }

      restApiCall({
         code,
         key: storedEpicLoginKey,
         callback: (resultStatus) => {
            if (isLoadedOnWebView()) {
               const customToken = resultStatus?.customToken;
               openAppEpic(customToken);
               return;
            }
            SignUpProvider(resultStatus, history, true);
            localStorage.removeItem("epicLoginKey");
         },
         error: () => {
            history.push("/login");
         },
      });
   };

   const loginEpicUser = (code) => {
      const storedEpicLoginKey = localStorage.getItem("epicLoginKey");
      if (!storedEpicLoginKey) {
         return;
      }

      restApiCall({
         code,
         key: storedEpicLoginKey,
         callback: (resultStatus) => {
            if (isLoadedOnWebView()) {
               const customToken = resultStatus?.customToken;
               openAppEpic(customToken);
               return;
            }
            SignUpProvider(resultStatus, history, true);
            localStorage.removeItem("epicLoginKey");
         },
         error: () => {
            history.push("/login");
         },
      });
   };

   return (
      <div className="flex-center" style={{ width: "90%", margin: "auto", paddingTop: "30px", height: "100vh" }}>
         <div className="text-center">
            <CircleLoader />
         </div>
      </div>
   );
};

export default withRouter(FhirClientStandAloneComponent);
